// infrastructure layer adapter for mapbox popup
import React from 'react';
import { Popup } from 'react-map-gl';
import type { PointLike, MapRef } from 'react-map-gl';
import mapboxgl from 'mapbox-gl';
import PublicPropertyPopup from '../../../public-property-popup/presentation/components/PublicPropertyPopup';
import {
  getMapboxPopupOrientationAndOffset,
  POPUP_WIDTH,
  Z_INDEX_MAP_POPUP
} from '../../../../utility/mapUtilities';

type PopupProps = {
  popupInfo: {
    id: string;
    property_id: string;
    latitude: number;
    longitude: number;
  };
  popupHeight: number;
  mapNode: MapRef;
  markerRef: mapboxgl.Marker;
  onClose: () => void;
  setPopupHeight: (h: number) => void;
  setPopupLoading: (b: boolean) => void;
};

export function renderPropertyPopup({
  popupInfo,
  popupHeight,
  mapNode,
  markerRef,
  onClose,
  setPopupHeight,
  setPopupLoading,
}: PopupProps): JSX.Element | null {
  if (!popupInfo) return null;

  const orientationData = getMapboxPopupOrientationAndOffset(
    markerRef,
    mapNode,
    popupHeight
  );

  if (!orientationData) return null;

  const [ orientation, offset ]: [any, PointLike] = orientationData;

  return (
    <Popup
      latitude={popupInfo.latitude}
      longitude={popupInfo.longitude}
      maxWidth={`${POPUP_WIDTH}px`}
      anchor={orientation}
      offset={offset}
      closeOnMove={true}
      closeButton={false}
      onClose={onClose}
      style={{
        zIndex: Z_INDEX_MAP_POPUP,
        visibility: popupHeight > 0 ? 'visible' : 'hidden',
      }}
    >
      <PublicPropertyPopup
        propertyId={popupInfo.property_id}
        setPopupLoading={setPopupLoading}
        setHeight={setPopupHeight}
        closePopup={onClose}
      />
    </Popup>
  );
}
